import { createAction } from "redux-actions";
import { PAGES, ActionConstants } from "../constants";
import {FIRST_NAME_SAME_TO_SURNAME} from "../constants/errorMessagesConstants";

const initialState = {
    currentPage: PAGES.FIRST_STEP,
    modalOpen: false,
    isDesktop: true,

    isLoadingStep1: false,

    emailData: {
        value: '',
        status: 0,
        message: ''
    },

    firstNameData: {
        value: '',
        status: 0,
        message: ''
    },

    surnameData: {
        value: '',
        status: 0,
        message: ''
    },

    birthdayData: {
        day: '',
        month: '',
        year: '',
        status: 0,
        message: ''
    },

    promocodeData: {
        value: '',
        status: 0,
        message: '',
    },

    isPromocodeInQueryString: false,
    btagValue: '',

    isLoadingStep2: false,
    isLoadingStates: false,

    usernameData: {
        value: '',
        status: 0,
        message: '',
        suggestions: []
    },

    passwordData: {
        value: '',
        status: 0,
        message: '',
        errorCodes: []
    },

    statesData: {
        value: '',
        status: 0,
        message: '',
        states: []
    },

    phoneData: {
        value: '',
        status: 0,
        message: '',
        oldValue: '',
    },

    isLoadingStepSms: false,

    resendAvailable: false,
    otpMessage: '',
    otpError: false,
    showOtpRemainingTime: false,
    otpExpiredAttempts: false,
    otpExpiredTime: false,
    otpCountDownMessage: '',

    pendingRegistrationId: 0,
    createAccountMessageError: '',
    crateAccountSuccess: true,

    clientId: null,
    gtmRegistrationStartSent: false,
    gtmRegistrationFirstInteractionSent: false,
    gtmRegistrationSuccessSent: false
};

export default function loyaltiesReducer(state = initialState, action) {
    let payload = action.payload;

    switch (action.type) {
        case ActionConstants.SET_IS_DESKTOP:
            return {
                ...state,
                isDesktop: action.payload
            }
        case ActionConstants.UPDATE_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.payload
            }
        case ActionConstants.UPDATE_EMAIL_DATA_ACTION:
            return {
                ...state,
                emailData: {
                    value: action.payload.value,
                    status: action.payload.status,
                    message: action.payload.message
                },
            }
        case ActionConstants.UPDATE_FIRST_NAME_DATA_ACTION:
            let surnameData = null;
            if (action.payload.message !== FIRST_NAME_SAME_TO_SURNAME) {
                if (state.surnameData.message === FIRST_NAME_SAME_TO_SURNAME) {
                    surnameData = {
                        value: state.surnameData.value,
                        status: state.surnameData.value === '' ? 0 : 1,
                        message: ''
                    }
                }
            }

            return {
                ...state,
                surnameData: surnameData != null ? surnameData : state.surnameData,
                firstNameData: {
                    value: action.payload.value,
                    status: action.payload.status,
                    message: action.payload.message
                },
            }
        case ActionConstants.UPDATE_SURNAME_DATA_ACTION:
            let firstNameData = null;
            if (action.payload.message !== FIRST_NAME_SAME_TO_SURNAME) {
                if (state.firstNameData.message === FIRST_NAME_SAME_TO_SURNAME) {
                    firstNameData = {
                        value: state.firstNameData.value,
                        status: state.firstNameData.value === '' ? 0 : 1,
                        message: ''
                    }
                }
            }

            return {
                ...state,
                firstNameData: firstNameData != null ? firstNameData : state.firstNameData,
                surnameData: {
                    value: action.payload.value,
                    status: action.payload.status,
                    message: action.payload.message
                },
            }
        case ActionConstants.UPDATE_BIRTHDAY_DATA_ACTION:
            return {
                ...state,
                birthdayData: action.payload
            }
        case ActionConstants.VALIDATE_PROMOCODE:
            return {
                ...state,
                promocodeData: {
                    value: action.payload.promocode,
                    status: 0,
                    message: ''
                },
                isPromocodeInQueryString: action.payload.isInQueryString != null ? action.payload.isInQueryString : false,
                isLoadingStep1: true
            }
        case ActionConstants.VALIDATE_PROMOCODE_SUCCESS:
            return {
                ...state,
                promocodeData: {
                    ...state.promocodeData,
                    status: 1,
                    message: ''
                },
                isLoadingStep1: false
            }
        case ActionConstants.VALIDATE_PROMOCODE_FAILURE:
            return {
                ...state,
                promocodeData: {
                    ...state.promocodeData,
                    status: -1,
                    message: payload.result != null && payload.result.error != null ? payload.result.error.message : ''
                },
                isLoadingStep1: false
            }
        case ActionConstants.UPDATE_BTAG_AS_SITE_ID:
            return {
                ...state,
                btagValue: action.payload.btag !== null ? action.payload.btag : '',
            }
        case ActionConstants.RESET_PROMOCODE:
            return {
                ...state,
                promocodeData: {
                    value: '',
                    status: 0,
                    message: ''
                }
            }
        case ActionConstants.VALIDATE_STEP_1:
            return {
                ...state,
                isLoadingStep1: true,
                gtmRegistrationStartSent: true,
            }
        case ActionConstants.VALIDATE_STEP_1_SUCCESS:
            return {
                ...state,
                isLoadingStep1: false,
                currentPage: PAGES.SECOND_STEP
            }
        case ActionConstants.VALIDATE_STEP_1_FAILURE:
            let emailMessage = '';
            let firstNameMessage = '';
            let surnameMessage = '';
            let birthdayMessage = '';

            if (action.payload.result != null && action.payload.result.validationErrors != null) {
                let validationErrors = action.payload.result.validationErrors;
                if (validationErrors.emailError) {
                    emailMessage = validationErrors.emailError;
                }

                if (validationErrors.firstNameError) {
                    firstNameMessage = validationErrors.firstNameError;
                }

                if (validationErrors.lastNameError) {
                    surnameMessage = validationErrors.lastNameError;
                }

                if (validationErrors.birthDateError) {
                    birthdayMessage = validationErrors.birthDateError;
                }
            }

            return {
                ...state,
                isLoadingStep1: false,
                emailData: {
                    ...state.emailData,
                    status: emailMessage !== '' ? -1 : state.emailData.status,
                    message: emailMessage
                },
                firstNameData: {
                    ...state.firstNameData,
                    status: firstNameMessage !== '' ? -1 : state.firstNameData.status,
                    message: firstNameMessage
                },
                surnameData: {
                    ...state.surnameData,
                    status: surnameMessage !== '' ? -1 : state.surnameData.status,
                    message: surnameMessage
                },
                birthdayData: {
                    ...state.birthdayData,
                    status: birthdayMessage !== '' ? -1 : state.birthdayData.status,
                    message: birthdayMessage
                },
            }
        case ActionConstants.GET_STATES:
            return {
                ...state,
                isLoadingStates: true
            }
        case ActionConstants.GET_STATES_SUCCESS:
            return {
                ...state,
                isLoadingStates: false,
                statesData: {
                    value: '',
                    message: '',
                    states: action.payload.result,
                    status: 0
                }
            }
        case ActionConstants.GET_STATES_FAILURE:
            return {
                ...state,
                isLoadingStates: false,
                statesData: {
                    value: '',
                    message: 'Error loading states',
                    states: [],
                    status: -1
                }
            }
        case ActionConstants.UPDATE_USERNAME_DATA_ACTION:
            return {
                ...state,
                usernameData: {
                    value: action.payload.value,
                    status: action.payload.status,
                    message: action.payload.message,
                    suggestions: action.payload.suggestions
                },
            }
        case ActionConstants.UPDATE_PASSWORD_DATA_ACTION:
            return {
                ...state,
                passwordData: {
                    value: action.payload.value,
                    status: action.payload.status,
                    message: action.payload.message,
                    errorCodes: action.payload.errorCodes,
                },
            }
        case ActionConstants.UPDATE_STATE_DATA_ACTION:
            return {
                ...state,
                statesData: {
                    states: state.statesData.states,
                    value: action.payload.value,
                    status: action.payload.status,
                    message: action.payload.message
                },
            }
        case ActionConstants.UPDATE_PHONE_DATA_ACTION:
            return {
                ...state,
                phoneData: {
                    ...state.phoneData,
                    value: action.payload.value,
                    status: action.payload.status,
                    message: action.payload.message
                },
            }
        case ActionConstants.VALIDATE_STEP_2:
            return {
                ...state,
                isLoadingStep2: true
            }
        case ActionConstants.VALIDATE_STEP_2_SUCCESS:
            return {
                ...state,
                isLoadingStep2: false,
                currentPage: PAGES.SMS_STEP,
                pendingRegistrationId: action.payload.result,
                otpExpiredAttempts: state.phoneData.value === state.phoneData.oldValue && state.otpExpiredAttempts === true,
                otpExpiredTime: state.phoneData.value === state.phoneData.oldValue && state.otpExpiredTime === true,
                otpMessage: state.phoneData.value === state.phoneData.oldValue && state.otpExpiredAttempts === true ?
                    state.otpMessage : '',
                otpCountDownMessage: state.phoneData.value === state.phoneData.oldValue && state.otpCountDownMessage === true ?
                    state.otpMessage : '',
                phoneData: {
                    ...state.phoneData,
                    oldValue: state.phoneData.value
                },

            }
        case ActionConstants.VALIDATE_STEP_2_FAILURE:
            let usernameMessage = '';
            let usernameSuggestions = [];
            let passwordMessage = '';
            let phoneMessage = '';

            if (action.payload.error != null) {
                if (action.payload.error.code === -19701) {
                    if (action.payload.result.validationErrors != null) {
                        let validationErrors = action.payload.result.validationErrors;

                        if (validationErrors.usernameError) {
                            usernameMessage = validationErrors.usernameError;

                            if (action.payload.result.usernameSuggestions) {
                                usernameSuggestions = action.payload.result.usernameSuggestions;
                            }
                        }

                        if (validationErrors.passwordError) {
                            passwordMessage = validationErrors.passwordError;
                        }

                        if (validationErrors.phoneError) {
                            phoneMessage = validationErrors.phoneError;
                        }
                    }
                } else if (action.payload.error.code === -19749) {
                    phoneMessage = action.payload.result.message;
                }
            }

            return {
                ...state,
                isLoadingStep2: false,
                usernameData: {
                    ...state.usernameData,
                    status: usernameMessage !== '' ? -1 : state.usernameData.status,
                    message: usernameMessage,
                    suggestions: usernameSuggestions.length > 0 ? usernameSuggestions : state.usernameData.suggestions
                },
                passwordData: {
                    ...state.passwordData,
                    status: passwordMessage !== '' ? -1 : state.passwordData.status,
                    message: passwordMessage
                },
                phoneData: {
                    ...state.phoneData,
                    status: phoneMessage !== '' ? -1 : state.phoneData.status,
                    message: phoneMessage
                },
            }
        case ActionConstants.RESEND_VERIFICATION_SMS_ACTION:
            return {
                ...state,
                isLoadingStepSms: true,
                resendAvailable: false,
                otpError: false,
                otpMessage: '',
            }
        case ActionConstants.RESEND_VERIFICATION_SMS_ACTION_SUCCESS:
            return {
                ...state,
                isLoadingStepSms: false,
                otpError: false,
            }
        case ActionConstants.RESEND_VERIFICATION_SMS_ACTION_FAILURE:
            return {
                ...state,
                isLoadingStepSms: false,
                otpError: true,
                otpMessage: action.payload?.result?.message ? action.payload.result.message : 'Error sending OTP'
            }
        case ActionConstants.SET_RESEND_OTP_AVAILABLE:
            return {
                ...state,
                resendAvailable: action.payload
            }
        case ActionConstants.UPDATE_OTP_MESSAGE_ACTION:
            return {
                ...state,
                otpMessage: action.payload,
            }
        case ActionConstants.UPDATE_OTP_COUNTDOWN_MESSAGE_ACTION:
            return {
                ...state,
                otpCountDownMessage: action.payload,
            }
        case ActionConstants.UPDATE_OTP_EXPIRED_TIME_ACTION:
            return {
                ...state,
                otpExpiredTime: action.payload.otpExpiredTime,
                otpCountDownMessage: action.payload.otpCountDownMessage,
            }
        case ActionConstants.CREATE_ACCOUNT_ACTION:
            return {
                ...state,
                isLoadingStepSms: true,
                otpMessage: '',
            }
        case ActionConstants.CREATE_ACCOUNT_ACTION_SUCCESS:
            return {
                ...state,
                currentPage: PAGES.COMPLETE_STEP,
                createAccountMessageError: '',
                isLoadingStepSms: false,
                createAccountSuccess: true,
                clientId: action.payload.result != null && action.payload.result.clientId != null ?
                    action.payload.result.clientId : null
            }
        case ActionConstants.CREATE_ACCOUNT_ACTION_FAILURE:
            let createAccountMessageError = '';

            if (action.payload.result != null && action.payload.result.code != null && [-19745, -19746, -19728, -19747, -19748].includes(action.payload.result.code)) {
                createAccountMessageError = action.payload.result.message;

                const otpExpiredAttempts =  action.payload.result.code === -19745;

                if (otpExpiredAttempts === true) {
                    return {
                        ...state,
                        otpMessage: createAccountMessageError,
                        isLoadingStepSms: false,
                        createAccountSuccess: false,
                        otpExpiredAttempts: true,
                        resendAvailable: false
                    }
                } else {
                    return {
                        ...state,
                        otpMessage: createAccountMessageError,
                        isLoadingStepSms: false,
                        createAccountSuccess: false,
                        otpExpiredAttempts: otpExpiredAttempts
                    }
                }
            } else {
                return {
                    ...state,
                    currentPage: PAGES.COMPLETE_STEP,
                    createAccountMessageError: action.payload.result != null && action.payload.result.message != null ? action.payload.result.message : '',
                    isLoadingStepSms: false,
                    createAccountSuccess: false
                }
            }
        case ActionConstants.UPDATE_GTM_REGISTRATION_FIRST_INTERACTION_SENT:
            return {
                ...state,
                gtmRegistrationFirstInteractionSent: true
            }
        case ActionConstants.UPDATE_GTM_REGISTRATION_SUCCESS_SENT:
            return {
                ...state,
                gtmRegistrationSuccessSent: true
            }
        default:
            return state;
    }
}

export const setIsDesktopAction = createAction(ActionConstants.SET_IS_DESKTOP);
export const updateCurrentPageAction = createAction(ActionConstants.UPDATE_CURRENT_PAGE);
export const updateEmailDataAction = createAction(ActionConstants.UPDATE_EMAIL_DATA_ACTION);
export const updateFirstNameDataAction = createAction(ActionConstants.UPDATE_FIRST_NAME_DATA_ACTION);
export const updateSurnameDataAction = createAction(ActionConstants.UPDATE_SURNAME_DATA_ACTION);
export const updateBirthdayDataAction = createAction(ActionConstants.UPDATE_BIRTHDAY_DATA_ACTION);
// export const updatePromocodeDataAction = createAction(ActionConstants.UPDATE_PROMOCODE_DATA_ACTION);
export const validatePromocodeAction = createAction(ActionConstants.VALIDATE_PROMOCODE);
export const resetPromocodeAction = createAction(ActionConstants.RESET_PROMOCODE);
export const validateStep1Action = createAction(ActionConstants.VALIDATE_STEP_1);
export const updateUsernameDataAction = createAction(ActionConstants.UPDATE_USERNAME_DATA_ACTION);
export const updatePasswordDataAction = createAction(ActionConstants.UPDATE_PASSWORD_DATA_ACTION);
export const updateStateDataAction = createAction(ActionConstants.UPDATE_STATE_DATA_ACTION);
export const updatePhoneDataAction = createAction(ActionConstants.UPDATE_PHONE_DATA_ACTION);
export const validateStep2Action = createAction(ActionConstants.VALIDATE_STEP_2);
export const getStatesAction = createAction(ActionConstants.GET_STATES);
export const resendVerificationSmsAction = createAction(ActionConstants.RESEND_VERIFICATION_SMS_ACTION);
export const setResendOtpAvailableAction = createAction(ActionConstants.SET_RESEND_OTP_AVAILABLE);
export const updateOtpCountDownMessageAction = createAction(ActionConstants.UPDATE_OTP_COUNTDOWN_MESSAGE_ACTION);
export const updateOtpExpiredTimeAction = createAction(ActionConstants.UPDATE_OTP_EXPIRED_TIME_ACTION);
export const createAccountAction = createAction(ActionConstants.CREATE_ACCOUNT_ACTION);
export const updateGtmRegistrationFirstInteractionSentAction = createAction(ActionConstants.UPDATE_GTM_REGISTRATION_FIRST_INTERACTION_SENT);
export const updateGtmRegistrationSuccessSentAction = createAction(ActionConstants.UPDATE_GTM_REGISTRATION_SUCCESS_SENT);
export const updateBtagAsSiteIdAction = createAction(ActionConstants.UPDATE_BTAG_AS_SITE_ID);